// Layout.tsx
import React, { useEffect, useState } from "react";
import Topbar from "./components/Topbar/Topbar";
import Sidebar from "./components/Sidebar/Sidebar";
import Toaster from "./components/Toaster/Toaster";
import Spinner from "./components/Spinner/Spinner";
import Footer from "./components/Footer/Footer";
import TopbarMobile from "./components/Topbar/TopbarMobile";


interface LayoutProps {
  children: React.ReactNode;
  sideBarLinks?: Array<{ path: string; element: React.ReactNode; label: string }>; 
  isLoginPage?: boolean; 
}


const Layout: React.FC<LayoutProps> = ({ children, sideBarLinks, isLoginPage }) => {

  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1204);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
  
      <div className="layout">
        <Toaster />
        <Spinner />
        <div className="layout-wrap">
         {!isLoginPage && (
          isDesktop ? <Topbar /> : <TopbarMobile />
        )}
        <div className="main-content">
          {/* {!isLoginPage && <Sidebar links={sideBarLinks} />} */}
          <div className="content">{children}</div>
        </div>
        
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
